import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

const PTypography = styled((props) => <Typography {...props}/>)(({ theme, mycolor }) => ({
    backgroundColor: mycolor,
    padding: "0px 4px",
    border: "2px solid transparent",
    borderRadius: "4px",
    // cursor: "pointer",
    transition: "background-color 300ms linear",
    width:"max-content",
    overflowX: "hidden",
}))

export {PTypography}